export const BankIcon = ({
  strokeColor = "var(--color-icon-obscure)",
  ...props
}: any) => (
  <svg {...props} width="60" height="60" viewBox="0 0 60 60" fill="none">
    <g id="vuesax/bulk/bank">
      <g id="bank">
        <path
          id="Vector"
          d="M55 47.5V55H5V47.5C5 46.125 6.125 45 7.5 45H52.5C53.875 45 55 46.125 55 47.5Z"
          fill={strokeColor}
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          opacity="0.6"
          d="M20 27.5H10V45H20V27.5Z"
          fill={strokeColor}
        />
        <path
          id="Vector_3"
          opacity="0.4"
          d="M30 27.5H20V45H30V27.5Z"
          fill={strokeColor}
        />
        <path
          id="Vector_4"
          opacity="0.6"
          d="M40 27.5H30V45H40V27.5Z"
          fill={strokeColor}
        />
        <path
          id="Vector_5"
          opacity="0.4"
          d="M50 27.5H40V45H50V27.5Z"
          fill={strokeColor}
        />
        <path
          id="Vector_6"
          d="M57.5 56.875H2.5C1.475 56.875 0.625 56.025 0.625 55C0.625 53.975 1.475 53.125 2.5 53.125H57.5C58.525 53.125 59.375 53.975 59.375 55C59.375 56.025 58.525 56.875 57.5 56.875Z"
          fill={strokeColor}
        />
        <path
          id="Vector_7"
          d="M53.425 14.3745L30.925 5.37461C30.425 5.17461 29.575 5.17461 29.075 5.37461L6.57501 14.3745C5.70001 14.7245 5 15.7495 5 16.6995V24.9995C5 26.3745 6.125 27.4995 7.5 27.4995H52.5C53.875 27.4995 55 26.3745 55 24.9995V16.6995C55 15.7495 54.3 14.7245 53.425 14.3745ZM30 21.2495C27.925 21.2495 26.25 19.5745 26.25 17.4995C26.25 15.4245 27.925 13.7495 30 13.7495C32.075 13.7495 33.75 15.4245 33.75 17.4995C33.75 19.5745 32.075 21.2495 30 21.2495Z"
          fill={strokeColor}
        />
      </g>
    </g>
  </svg>
);
